// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__PY5Iz","text":"SelectPayment_text__2AA1s","title":"SelectPayment_title__3sqZ3","btn":"SelectPayment_btn__24s8v"};